import { useMutation } from '@tanstack/react-query';

import { useResetUserInfo, useUserInfo } from '@/features/users';

import { saveImage } from '../api';

export const useStoreImage = (uuid: string) => {
  const resetUserInfo = useResetUserInfo();
  const user = useUserInfo();

  return useMutation({
    mutationKey: ['saveImage'],
    mutationFn: saveImage,
    onSuccess: async (_data) => {
      if (uuid === user.user_id) {
        await resetUserInfo();
      }
    },
    onError: (_error) => {},
  });
};
